import React, {Component} from 'react'
import '../../../styles/Admin.css'
import AdminService from "../AdminService";
import Dropzone from "react-dropzone";
import AdminPlikiService from "../AdminPlikiService";
import {Button} from "react-bootstrap";
import {NotificationManager} from "react-notifications";

export default class ZarzadzaniePlikami extends Component {

    constructor(props) {
        super(props);

        this.state = {
            plik: [],
            plikShow: [],
            plik2: [],
            plik2Show: [],
            plikInvalid: false,
            plik2Invalid: false,
            loading: false,
            warunki: [],
            polityka: [],
            warunkiOpis: '',
            politykaOpis: ''
        };

        this.handleWarunki = this.handleWarunki.bind(this);
        this.handlePolityka = this.handlePolityka.bind(this)

    }

    componentWillMount() {
        AdminPlikiService.getPlik('polityka-prywatnosci')
            .then(function (response) {
                this.setState({polityka: response.data, politykaOpis: response.data.opis})
            }.bind(this)).catch(err => {
            console.log(err)
        }).then(() => {
            AdminPlikiService.getPlik('warunki-przewozu')
                .then(function (res) {
                    this.setState({loading: false, warunki: res.data, warunkiOpis: res.data.opis});
                    console.log(res)
                }.bind(this)).catch(err => {
                console.log(err)
            })
        })

    }

    componentWillReceiveProps() {
        this.componentWillMount()
    }

    checkPublikacja(item) {
        if (item) {
            return <i className={'fa fa-check'} style={{color: '#57b13c'}}> </i>
        } else {
            return <i className={'fa fa-times'} style={{color: 'red'}}> </i>
        }
    }

    handleWarunki(e) {
        this.setState({warunkiOpis: e.target.value})
    }

    handlePolityka(e) {
        this.setState({politykaOpis: e.target.value})
    }

    renderAkcje(item) {
        return <div>
            <i className="fa fa-trash" aria-hidden="true" style={{paddingLeft: 10}}
               onClick={() => this.deleteItem(item)}> </i>
        </div>
    }

    deleteItem(item) {
        if (window.confirm("Czy na pewno chcesz usunąć plik?")) {
            AdminService.deleteStrona(item.id)
                .then(function (response) {
                    this.componentWillMount()
                }.bind(this)).catch(err => {
                console.log(err)
            })
        } else {
            return null;
        }
    }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({plikInvalid: true, plik: '', plikShow: ''})
        } else {
            this.setState({plikInvalid: false});
            this.getBase64(accepted)
        }
    }

    onDropPolityka(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({plik2Invalid: true, plik2: '', plik2Show: ''})
        } else {
            this.setState({plik2Invalid: false});
            this.getBase64Polityka(accepted)
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState({
                plikShow: {
                    dane: reader.result.split(",")[1],
                    nazwa: file[0].name,
                    dokumentTyp: "STRONA_WPIS",
                    typ: file[0].type,
                    rozmiar: file[0].size,
                }
            });
            this.setState({plik: ''})
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    getBase64Polityka(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState({
                plik2Show: {
                    dane: reader.result.split(",")[1],
                    nazwa: file[0].name,
                    dokumentTyp: "STRONA_WPIS",
                    typ: file[0].type,
                    rozmiar: file[0].size,
                }
            });
            this.setState({plik2: ''})
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    addWarunki() {
        AdminPlikiService.putPlik(this.state.plikShow.dane, 'PUBLIC', this.state.plikShow.nazwa, this.state.plikShow.rozmiar, 'warunki-przewozu', this.state.plikShow.typ, this.state.warunkiOpis)
            .then(function (response) {
                NotificationManager.success("", "Warunki przewozu zostały zaktualizowane ", 5000);
                this.setState({plikShow: '', plik: ''})
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    addPolityka() {
        AdminPlikiService.putPlik(this.state.plik2Show.dane, 'PUBLIC', this.state.plik2Show.nazwa, this.state.plik2Show.rozmiar, 'polityka-prywatnosci', this.state.plik2Show.typ, this.state.politykaOpis)
            .then(function (response) {
                NotificationManager.success("", "Polityka prywatności została zaktualizowana ", 5000);
                this.setState({plik2Show: '', plik2: ''})
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    render() {
        return <div className="aktualnosciTabContainer">

            <div className="aktualnosciOpis">
                Ta zakładka umożliwia zarządzanie plikami. Aby usunąć istniejący plik należy wybrać przycisk po prawej
                stronie danego wpisu.
                Aby dodać nowy plik należy przejść do zakładki <span style={{cursor: 'pointer'}}
                                                                     onClick={() => this.props.goNowyWpis()}>
                    <b> nowy plik</b>
                </span>.
            </div>
            <div className="aktualnosciWpisy">
                <div className="row wynik" style={{lineHeight: '38px'}}>
                    <div className="col-4 text-center">
                        <input type={'text'} style={{fontWeight: 'bold', textAlign: 'center'}}
                               onChange={this.handleWarunki.bind(this)} value={this.state.warunkiOpis}
                               className="form-control"/>
                    </div>
                    <div className="col-4">
                        <input type="text" className="form-control"
                               value={this.state.warunki.link}/>
                    </div>
                    <div className="col-1 text-center">
                        <a href={this.state.warunki.get}>Pobierz
                            plik</a>
                    </div>
                    <div className="col-2">
                        <Dropzone maxSize={2000000} acceptedFiles="pdf"
                                  style={{
                                      height: 38,
                                      border: '1px dashed #ced4da',
                                      borderRadius: '0.25rem',
                                      textAlign: 'center',
                                      fontSize: '0.875rem',
                                      color: '#565756',
                                      cursor: 'pointer'
                                  }}
                                  onDrop={(accepted, rejected) => {
                                      this.onDrop(accepted, rejected)
                                  }}>
                            <div>{this.state.plikInvalid ?
                                <div style={{color: 'red'}}>Podany plik jest niepoprawny!</div> : <div>
                                    {this.state.plikShow.length === 0 ? 'Przeciągnij lub wybierz plik...' :
                                        <div>
                                            <i className="fa fa-file-o"/> {this.state.plikShow.nazwa}</div>}
                                </div>}
                            </div>

                        </Dropzone>
                    </div>
                    <div className="col-1">
                        <Button onClick={() => this.addWarunki()} disabled={this.state.plikShow.length === 0}
                                bsStyle={this.state.plikShow.length === 0 ? 'disabled' : 'success'}
                                style={{height: '38px'}}>Dodaj</Button>
                    </div>
                </div>
                <div className="row wynik" style={{lineHeight: '38px'}}>
                    <div className="col-4 text-center">
                        <input type={'text'} style={{fontWeight: 'bold', textAlign: 'center'}}
                               onChange={this.handlePolityka.bind(this)} value={this.state.politykaOpis}
                               className="form-control"/>
                    </div>
                    <div className="col-4">
                        <input type="text" className="form-control"
                               value={this.state.polityka.link}/>
                    </div>
                    <div className="col-1 text-center">
                        <a href={this.state.polityka.get}>Pobierz
                            plik</a>
                    </div>
                    <div className="col-2">
                        <Dropzone maxSize={2000000} acceptedFiles="pdf"
                                  style={{
                                      height: 38,
                                      border: '1px dashed #ced4da',
                                      borderRadius: '0.25rem',
                                      textAlign: 'center',
                                      fontSize: '0.875rem',
                                      color: '#565756',
                                      cursor: 'pointer'
                                  }}
                                  onDrop={(accepted, rejected) => {
                                      this.onDropPolityka(accepted, rejected)
                                  }}>
                            <div>{this.state.plik2Invalid ?
                                <div style={{color: 'red'}}>Podany plik jest niepoprawny!</div> : <div>
                                    {this.state.plik2Show.length === 0 ? 'Przeciągnij lub wybierz plik...' :
                                        <div><i className="fa fa-file-o"/> {this.state.plik2Show.nazwa}</div>}
                                </div>}
                            </div>
                        </Dropzone>
                    </div>
                    <div className="col-1">
                        <Button onClick={() => this.addPolityka()} disabled={this.state.plik2Show.length === 0}
                                bsStyle={this.state.plik2Show.length === 0 ? 'disabled' : 'success'}
                                style={{height: '38px'}}>Dodaj</Button>
                    </div>
                </div>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/plikiComponents/ZarzadzaniePlikami.js